var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSort = function SvgIconSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 13.282H7v-7.5a1 1 0 1 0-2 0v7.5H2.45c-.392 0-.596.447-.329.721l3.55 3.642c.178.182.48.182.658 0l3.55-3.642c.267-.274.063-.721-.329-.721M10.45 8.282H13v7.5a1 1 0 1 0 2 0v-7.5h2.55c.392 0 .596-.447.329-.722l-3.55-3.642a.463.463 0 0 0-.658 0l-3.55 3.642c-.267.275-.064.722.329.722"
  })));
};
export default SvgIconSort;